module.exports = __webpack_public_path__ + "media/images/front/sp_tl-menu-172ac8f24cd73be25a0f273d3c3f6825.png";